'use client';

import { type JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import { Label } from '@videoblocks/design-system';

import { UseCaseCard } from './UseCaseCard';

export type UseCaseItem = {
    id: string;
    title: string;
    imgUrl: string;
};

export type UseCaseSelectorProps = {
    useCases: UseCaseItem[];
    selectedUseCaseId: string | null;
    onSelect: (id: string) => void;
    disabled?: boolean;
    className?: string;
};

export function UseCaseSelector({
    useCases,
    selectedUseCaseId,
    onSelect,
    disabled = false,
    className,
}: UseCaseSelectorProps): JSX.Element {
    return (
        <div className={twMerge('flex flex-col gap-2 w-full', className)}>
            <Label className="text-left" fontSize="sm" fontWeight="bold">
                Select an edit style
            </Label>
            <div className="@container">
                <div className="grid grid-cols-2 xl:grid-cols-3 gap-1 @min-[320px]:gap-2">
                    {useCases.map((useCase) => (
                        <UseCaseCard
                            key={useCase.id}
                            useCase={useCase}
                            isActive={selectedUseCaseId === useCase.id}
                            disabled={disabled}
                            onSelect={onSelect}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
